@if (_reportTemplate) {
  <div class="padding">
    <mat-card>
      <mat-card-content>
        <div class="content">
          <h1>{{ _reportTemplate.name }}</h1>
          <span class="spacer"></span>
          <button mat-fab [matTooltip]="'common.labels.saveReport' | transloco" matTooltipClass="reghub-tooltip" (click)="onSaveReport()"
            [attr.aria-label]="'reporting.buttonThatSavesTheCurrentReport' | transloco" color="accent">
            <mat-icon>save</mat-icon>
          </button>
        </div>
        <h3>{{ _reportTemplate.description }}</h3>
        <div class="table-container">
          <mat-tab-group animationDuration="0ms" [selectedIndex]="_selectedIndex">
            <mat-tab [label]="'common.labels.liveReport' | transloco">
              <app-live-template-report></app-live-template-report>
            </mat-tab>
            <mat-tab [label]="'common.labels.savedReports' | transloco">
              <app-saved-template-reports-list></app-saved-template-reports-list>
            </mat-tab>
            <!-- <mat-tab label="Schedule Reports">
            Coming Soon!
          </mat-tab> -->
        </mat-tab-group>
      </div>
    </mat-card-content>
  </mat-card>
</div>
}